function a(e) {
  const t = e.parentElement;
  t && (e.scrollWidth > e.clientWidth ? t.classList.add('has-overflow') : t.classList.remove('has-overflow'));
}
function f() {
  document.querySelectorAll('[data-drag-scroll]').forEach((e) => {
    let t = !1,
      r = 0,
      o = 0;
    a(e),
      window.addEventListener('resize', () => a(e)),
      e.addEventListener('mousedown', (s) => {
        (t = !0), (e.style.cursor = 'grabbing'), (r = s.pageX - e.offsetLeft), (o = e.scrollLeft);
      }),
      e.addEventListener('mouseleave', () => {
        (t = !1), (e.style.cursor = 'grab');
      }),
      e.addEventListener('mouseup', () => {
        (t = !1), (e.style.cursor = 'grab');
      }),
      e.addEventListener('mousemove', (s) => {
        if (!t) return;
        s.preventDefault();
        const n = s.pageX - e.offsetLeft - r;
        e.scrollLeft = o - n;
      });
  });
}
export {f as i};
